/**
 * Template de prise de besoin : Plan budgétaire 5 ans
 * Formulaire dédié (saisie tableau 5 ans + projets en cours, améliorations).
 * Le document "Plan budgétaire TI" est généré à partir de ces données.
 */

import type { IntakeTemplate } from '../templateTypes';

export const templatePlanBudgetaire5AnsV1: IntakeTemplate = {
  id: 'plan-budgetaire-5ans-v1',
  name: 'Prise de besoin - Plan budgétaire 5 ans',
  description:
    'Formulaire de saisie du plan budgétaire vision 5 ans : montants par poste et par année (infrastructure, logiciels, services TI, postes), avec projets en cours et améliorations faites/suggérées.',
  documentTypeCode: 'PLAN_BUDGETAIRE_5_ANS',
  version: '1.0.0',
  phases: [
    {
      id: 'phase1',
      title: 'Plan budgétaire vision 5 ans',
      description: 'Tableau budgétaire par catégorie et par année, projets en cours, améliorations.',
      icon: 'DollarSign',
      questions: [],
    },
  ],
};
